module.exports = __webpack_public_path__ + "static/media/marketing_icon.59c396fb.svg";